// Ek lead ka card: naam/number, kitni calls hui, status, aur recording ho to
// uska player. Card pe tap = us lead ka page (/leads/:leadId).
import React from "react";
import { useNavigate } from "react-router-dom";
import styles from "./PounceLeads.module.css";
import PounceAudioPlayer from "./PounceAudioPlayer";
// Business ke timezone me (lead.displayTimezone) — /leads wali screens jaisa.
import { formatWhen, isLimitWaiting } from "../../PounceLeadsPage/pounceLeadShared";

// `tone` = PounceLeads.module.css ki status class (rang wahin tay hote hain).
const STATUS = {
  new: { label: "New", tone: "statusNeutral" },
  calling: { label: "Calling", tone: "statusInfo" },
  booked: { label: "Booked", tone: "statusSuccess" },
  qualified_no_book: { label: "Hot lead", tone: "statusBrand" },
  not_interested: { label: "Not interested", tone: "statusNeutral" },
  no_answer: { label: "No answer", tone: "statusWarning" },
  bad_number: { label: "Bad number", tone: "statusDanger" },
  opted_out: { label: "Opted out", tone: "statusDanger" },
  blocked: { label: "Blocked", tone: "statusDanger" },
  failed: { label: "Failed", tone: "statusDanger" },
};


// Card ki baayin rangeen patti — status ke tone se. Jo yahan nahi, wo purple.
const ACCENT = {
  statusSuccess: "accentSuccess",
  statusWarning: "accentWarning",
  statusDanger: "accentDanger",
};

const pillIcon = (paths) => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    {paths}
  </svg>
);

// Status pill ke chhote icon — sirf sajawat, jis status ka nahi uska pill saada.
const STATUS_ICONS = {
  booked: pillIcon(<><rect x="3" y="5" width="18" height="16" rx="2" /><path d="M8 3v4M16 3v4M9 14l2 2 4-4" /></>),
  qualified_no_book: pillIcon(<><path d="M14 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9l-6-6Z" /><path d="M9 14l2 2 4-4" /></>),
  calling: pillIcon(<path d="M5 4h3l2 5-2.5 1.5a11 11 0 0 0 6 6L15 14l5 2v3a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2Z" />),
};

// Lead ki photo nahi hoti — naam ke pehle akshar; naam na ho to vyakti ka icon.
const initials = (name) =>
  String(name || "")
    .trim()
    .split(/\s+/)
    // Naam ki jagah number ("+9197…") ho to akshar nahi banta — icon dikhega.
    .filter((w) => /^\p{L}/u.test(w))
    .slice(0, 2)
    .map((w) => w[0].toUpperCase())
    .join("");


const PounceLeadRow = ({ lead, open, onToggle }) => {
  const status = isLimitWaiting(lead)
    ? { label: "Waiting", tone: "statusWarning" }
    : STATUS[lead.status] || { label: lead.status, tone: "statusNeutral" };
  const navigate = useNavigate();

  const calls = (lead.attempts || []).filter((a) => a.status !== "skipped");
  const last = [...calls].sort((a, b) => b.attemptNo - a.attemptNo)[0];
  const avatarText = initials(lead.name);

  return (
    <li className={`${styles.lead} ${styles[ACCENT[status.tone]] || ""}`}>
      <button type="button" className={styles.leadRow} onClick={() => navigate(`/leads/${lead.id}`)}>
        <span className={styles.avatar} aria-hidden="true">
          {avatarText || (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="8" r="4" />
              <path d="M4 21a8 8 0 0 1 16 0" />
            </svg>
          )}
        </span>
        <span className={styles.leadText}>
          <span className={styles.leadName}>{lead.name || lead.phone}</span>
          <span className={styles.leadMeta}>
            {lead.name ? `${lead.phone} · ` : ""}
            {calls.length} of {lead.maxAttempts} calls
          </span>
        </span>
        <span className={`${styles.status} ${styles[status.tone]}`}>
          {STATUS_ICONS[lead.status]}
          {status.label}
        </span>
        <svg
          className={styles.chevron}
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          aria-hidden="true"
        >
          <path d="M9 6l6 6-6 6" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </button>

      {/* Recording card pe hi — button ke bahar, taaki play dabane se lead ka
          page na khule. Baaki details (saar, kab aayi) lead ke page pe hain. */}
      {last?.recordingUrl && (
        <div className={styles.cardPlayer}>
          <PounceAudioPlayer src={last.recordingUrl} />
        </div>
      )}
    </li>
  );
};

export default PounceLeadRow;
